import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import styles from './Admin.module.css';

const AdminDashboard = () => {
  const { logout, isAuthenticated, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [submissions, setSubmissions] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!authLoading && !isAuthenticated) {
      navigate('/admin/login');
    }
  }, [isAuthenticated, authLoading, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      if (!isAuthenticated) return;
      try {
        const [subsRes, statsRes] = await Promise.all([
          api.get('/admin/submissions'),
          api.get('/admin/stats')
        ]);
        setSubmissions(subsRes.data.data);
        setStats(statsRes.data.data);
      } catch (error) {
        console.error('Failed to fetch admin data', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [isAuthenticated]);

  if (authLoading || loading) {
    return <div className={styles.adminContainer}><p>Loading secure portal...</p></div>;
  }

  return (
    <div className={styles.adminContainer}>
      <div className={styles.dashboardHeader}>
        <h1>Admin Dashboard</h1>
        <button onClick={logout} className={styles.logoutBtn}>Sign Out</button>
      </div>

      {stats && (
        <div className={styles.statsGrid}>
          <div className={styles.statCard}>
            <div className={styles.statValue}>{stats.total}</div>
            <div className={styles.statLabel}>Total Logs</div>
          </div>
          <div className={styles.statCard}>
            <div className={styles.statValue}>{stats.admissions}</div>
            <div className={styles.statLabel}>Admissions</div>
          </div>
          <div className={styles.statCard}>
            <div className={styles.statValue}>{stats.enquiry}</div>
            <div className={styles.statLabel}>Quick Leads</div>
          </div>
          <div className={styles.statCard}>
            <div className={styles.statValue}>{stats.contact}</div>
            <div className={styles.statLabel}>Contacts</div>
          </div>
        </div>
      )}

      <h2>Recent Submissions</h2>
      <div className={styles.tableContainer} style={{ marginTop: 20 }}>
        {submissions.length === 0 ? (
          <div className={styles.emptyState}>No submissions found. New form leads will appear here.</div>
        ) : (
          <table className={styles.submissionsTable}>
            <thead>
              <tr>
                <th>Date</th>
                <th>Type</th>
                <th>Name</th>
                <th>Phone / Email</th>
                <th>Program</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {submissions.map((sub) => (
                <tr key={sub.id}>
                  <td style={{ whiteSpace: 'nowrap', color: 'var(--gray)' }}>
                    {new Date(sub.createdAt).toLocaleDateString()} <br/>
                    <span style={{fontSize:11}}>{new Date(sub.createdAt).toLocaleTimeString()}</span>
                  </td>
                  <td>
                    <span className={`${styles.typeBadge} ${styles['type_' + sub.type]}`}>
                      {sub.type}
                    </span>
                  </td>
                  <td style={{ fontWeight: 600 }}>{sub.payload.name}</td>
                  <td>
                    {sub.payload.phone && <div>📞 {sub.payload.phone}</div>}
                    {sub.payload.email && <div>✉️ {sub.payload.email}</div>}
                  </td>
                  <td>{sub.payload.program || 'N/A'}</td>
                  <td style={{ maxWidth: 300, fontSize: 13, color: 'var(--gray)' }}>
                    {sub.payload.message ? (
                      <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {sub.payload.message}
                      </div>
                    ) : '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
